import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { FiberManualRecord, RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import { CourseAnnualDetailAPI } from "../../../../api/course-annual-detail/course-annual-detail.api";
import FilterSelect from "../../../../components/select/filterSelect";
import { MenuItem } from "@mui/material";
import { routeName } from "../../../../routes/routeName";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { degreeApi } from "../../../../api/degree/degree.api";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { getEnumValue } from "../../../../utils/common";
import { ADVISOR_ESTIMATE } from "../../../../domains/enum/estimate";
import { dateToView } from "../../../../utils/date.utils";

type Props = {};

const SubjectTaughtDetail: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_year = queryParams.get("year");
  const prop_term = queryParams.get("term");

  const [data, setData] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState([]);
  const [dataDegree, setDataDegree] = useState([]);

  const [search, setSearch] = useState<string>("");
  const [selectedFacultyId, setSelectedFacultyId] = useState<string>("");
  const [selectedDegreeId, setSelectedDegreeId] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const fetchGetFaculty = async () => {
    let query: any = {
      page: 1,
      limit: 1000,
    };

    const res = await facultyApi.getFaculty();
    const data = res.data;
    if (data.status < 300 && data.data && data.data.length > 0) {
      setDataFaculty(data.data);
    } else {
      setDataFaculty([]);
    }
  };

  const fetchGetDegree = async () => {
    let query: any = {
      page: 1,
      limit: 1000,
    };

    const res = await degreeApi.getDegree();
    const data = res.data;
    if (data.status < 300 && data.data && data.data.length > 0) {
      setDataDegree(data.data);
    } else {
      setDataDegree([]);
    }
  };

  useEffect(() => {
    fetchGetFaculty();
    fetchGetDegree()
  }, []);

  const getData = async (id: number) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
      id_faculty: selectedFacultyId ?? "",
      id_degree: selectedDegreeId ?? ''
    };

    const res = await CourseAnnualDetailAPI.getCourseAnnualListByIdCourseStudy(
      +id,
      query
    );
    const data = res.data;
    if (data.status < 300) {
      setData(res.data?.data?.items ?? []);
      setTotalItems(res.data?.data?.items.length || 0);
    } else {
      setData([]);
    }
  };

  const headCells = [
    // {
    //   id: "date",
    //   width: 25,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "วัน",
    // },
    // {
    //   id: "haft_date",
    //   width: 25,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "คาบ",
    // },
    // {
    //   id: "period",
    //   width: 100,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "ช่วงเวลา",
    // },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "รหัสวิชา",
    },
    {
      id: "period",
      width: 125,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อรายวิชา",
    },
    {
      id: "level",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ระดับ",
    },
    {
      id: "department",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "คณะ",
    },
    {
      id: "year",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชั้นปีที่",
    },
    {
      id: "room",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ห้อง",
    },
    // {
    //   id: "tacher",
    //   width: 100,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "อาจารย์ผู้สอน",
    // },
    {
      id: "unit",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "หน่วยกิต",
    },
    {
      id: "start_date",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "วันที่เริ่มต้นเปิดให้ประเมิน",
    },
    {
      id: "end_date",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "วันที่สิ้นสุดเปิดให้ประเมิน",
    },
    {
      id: "status",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "สถานะ",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  // study_day 0 === อาทิด
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_course_annual,
      id_course_of_study,
      term,
      room,
      id_courses,
      id_advisor_form,
      id_class_room,
      status,
      created_id,
      created_date,
      modified_id,
      modified_date,
      course_of_study,
      courses,
      course_annual_employee,
      estimate_start_date,
      estimate_end_date,
      estimate_status
    } = objData;

    let data_course_annual_employee = "";
    if (course_annual_employee) {
      const title = course_annual_employee?.employee?.title;
      const firstname = course_annual_employee?.employee?.first_name;
      const lastname = course_annual_employee?.employee?.last_name;

      data_course_annual_employee = title + " " + firstname + " " + lastname;
    }

    const objRenderData = {
      key: id_course_of_study,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: courses?.courses_no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: courses?.courses_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: course_of_study?.degree?.degree_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: course_of_study?.faculty?.faculty_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: term ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: room ?? "-",
        },
        // {
        //   option: "TEXT",
        //   align: "start",
        //   label: data_course_annual_employee ?? "-",
        // },
        {
          option: "TEXT",
          align: "start",
          label: courses?.credits,
        },
        {
          option: "TEXT",
          align: "start",
          label: estimate_start_date
            ? dateToView(estimate_start_date)
            : estimate_start_date,
        },
        {
          option: "TEXT",
          align: "start",
          label: estimate_end_date
            ? dateToView(estimate_end_date)
            : estimate_end_date,
        },
        {
          option: "COMPONENT",
          align: "start",
          component: (
            <CustomStatus
              label={
                getEnumValue(ADVISOR_ESTIMATE, estimate_status) ||
                "Unknown status"
              }
              type="outlined"
              color={
                estimate_status === ADVISOR_ESTIMATE.OPEN_FOR_ESTIMATE ||
                  estimate_status === ADVISOR_ESTIMATE.START_FOR_ESTIMATE
                  ? "success"
                  : estimate_status === ADVISOR_ESTIMATE.NOT_START_YET
                    ? "warning"
                    : "error"
              }
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  navigate(
                    routeName.advisor.SubjectTaught +
                    `/${id_course_annual}/course-annual-detail?courses_name=${courses?.courses_name}&courses_no=${courses?.courses_no}&id_course_of_study=${id_course_of_study}&year=${prop_year}&term=${prop_term}`
                  );
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    if (id) {
      getData(+id);
    }
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    selectedFacultyId,
    selectedDegreeId,
    id,
  ]);

  return (
    <div>
      <ContentHeading
        title={`รายวิชาที่สอน ปีการศึกษา ${prop_year} ภาคเรียนที่  ${prop_term}`}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อวิชา/รหัสวิชา"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <FilterSelect
            value={selectedDegreeId ?? ""}
            labelId="degree-id"
            selectId="degree-select-id"
            options={[
              {
                id_degree: "",
                degree_name: "ทุกระดับ",
              },
              ...dataDegree.map((item: any, index) => ({
                id_degree: item.id_degree,
                degree_name: item.degree_name,
              })),
            ].map((item, index) => (
              <MenuItem value={item.id_degree} key={index}>
                {item.degree_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSelectedDegreeId(e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <FilterSelect
            value={selectedFacultyId ?? ""}
            labelId="faculty-id"
            selectId="faculty-select-id"
            options={[
              {
                id_faculty: "",
                faculty_name: "ทุกหลักสูตร",
              },
              ...dataFaculty.map((item: any, index) => ({
                id_faculty: item.id_faculty,
                faculty_name: item.faculty_name,
              })),
            ].map((item, index) => (
              <MenuItem value={item.id_faculty} key={index}>
                {item.faculty_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSelectedFacultyId(e.target.value)
            }
          />
        </article>


      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1940}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default SubjectTaughtDetail;
